import React, { Component } from 'react'
import TextField from './../component/TextField'
import Dropdown from './../component/Dropdown'
import CheckBox from '../component/CheckBox';
import SearchIcon from '../icons/searchicon';

//Service import
import service from "../services";
import DropdownMaster from '../component/DropdownMaster';
//moment import
import moment from 'moment-timezone'
import FestDropDown from './festDropDown';
import _ from 'lodash'
let sub;
export default class FestTimeHome extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            checkList:[],
            festivalDay:'',
            options:[{value:"festivalEvents",name:"Festival Village"},{value:"talkEvents",name:"Talks & Events"},{value:"partnerEvents",name:"Partner & Events"}],
            beyondList:[
                 {_id:Math.random(),tile:'1',eventType:'Festival Village',searchTitle:'',idStore:'', checked: false,checkDetails:{}},
                 {_id:Math.random(),tile:'2',eventType:'Festival Village',searchTitle:'',idStore:'', checked: false,checkDetails:{}},
                 {_id:Math.random(),tile:'3',eventType:'Festival Village',searchTitle:'',idStore:'', checked: false,checkDetails:{}},
                 {_id:Math.random(),tile:'5',eventType:'Festival Village',searchTitle:'',idStore:'', checked: false,checkDetails:{}},
                 {_id:Math.random(),tile:'4',eventType:'Festival Village',searchTitle:'',idStore:'', checked: false,checkDetails:{}}
            ],
            storeID:''
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount = () => {
        this.apiserve.sendevent("homePage|beyondList|getList", {})
            sub = this.apiserve.getevent().subscribe((response) => {
              switch (response.event) {
                case "homePage|beyondList|getList":
                  if (!response.error) {
                      if(response.data._id){
                        response.data.beyondList.forEach(element => {
                            if(element.eventType === 'Festival Village' || element.eventType === 'festivalEvents'){
                                element.idStore = element?.festivalEvents?._id
                                element.checkDetails = element.festivalEvents
                            }else if(element.eventType === 'Partner & Events' || element.eventType === 'partnerEvents'){
                                element.idStore = element?.partnerEvents?._id
                                element.checkDetails = element.partnerEvents
                            } else {
                                element.idStore = element?.talkEvents?._id
                                element.checkDetails = element.talkEvents
                            }
                        });
                          this.setState({
                            beyondList:response.data.beyondList,
                            festivalDay:response.data.festivalDay
                          })
                      } 
                      }else {
                        this.setState({
                          loaderFlag: false,
                        })
                  
                  }
                  break;
                case "beyondFilm|getList":
                    case "partnerEvents|getList":
                    if (!response.error) {
                        this.setState({
                            checkList:response.data.docs
                        })
                    } else {
                        this.setState({
                        loaderFlag: false,
                        })
                    }
                    break;
                case "FestivalVillage|Event|searchEventForCms":
                if (!response.error) {
                        this.setState({
                            checkList:response.data.docs
                        })
                  } else {
                    this.setState({
                      loaderFlag: false,
                    })
                  }
                  break;
                case "homePage|beyondList|edit":
                    if (!response.error) {
                            this.apiserve.success('Update successfully.')
                      } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                      }
                break;
                  
                }
            })
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name] : value
        })
    }
    
    onChangeEventType = (e,id) => {
        const { name, value } = e.target;
        this.state.beyondList.forEach(element => {
            if(element._id === id){
                element[name] = value
            }
        });
        this.setState({})
    }

    checkListFestHome = (e,item,id,tid) => {
        const { checked } = e.target;
        var self= this;
        this.state.beyondList.forEach(element => {
        if(element._id === tid){
            self.state.checkList.forEach(searchId => {
                if(searchId._id === id){
                    element.checked = checked
                    element.idStore = id
                    element.checkDetails = item
                    element.searchTitle = ''
                }else{
                    element.checked = false
                }
            });
        }
        });
        this.setState({
            checkList:[]
        })
    }

    onSearchChange = (e,id) => {
        const { name, value } = e.target;
    
        this.state.beyondList.forEach(element => {
            if(element._id === id){
                element[name] = value
                if(element.eventType === 'Festival Village' || element.eventType === 'festivalEvents'){
                    if(value){
                        this.apiserve.sendevent("FestivalVillage|Event|searchEventForCms", {
                            "filter":value
                        })
                        this.setState({
                            storeID: id
                        })
                    }else{
                        this.setState({
                            checkList:[]
                        })
                    }
                    
                }else if (element.eventType === 'Talks & Events' || element.eventType === 'talkEvents') {
                     if(value){
                        this.apiserve.sendevent("beyondFilm|getList", {
                            "filter":value
                        })
                        this.setState({
                            storeID: id
                        })
                    }else{
                        this.setState({
                            checkList:[]
                        })
                    }
                    
                } else {
                    if(value){
                       this.apiserve.sendevent("partnerEvents|getList", {
                           "filter":value
                       })
                       this.setState({
                           storeID: id
                       })
                   }else{
                       this.setState({
                           checkList:[]
                       })
                   }
                   
               }
            }
        });
        this.setState({})
    }

    submitFn = () => {
        var data = []
        this.state.beyondList.forEach(element => {
            if(element.eventType === 'Festival Village' || element.eventType === 'festivalEvents'){
                data.push({
                    eventType: 'festivalEvents',
                    festivalEvents:element.idStore,
                    tile:element.tile
                })
            }else if(element.eventType === 'Talks & Events' || element.eventType === 'talkEvents'){
                data.push({
                    eventType: 'talkEvents',
                    talkEvents: element.idStore,
                    tile:element.tile
                })
            } else {
                data.push({
                    eventType: 'partnerEvents',
                    partnerEvents: element.idStore,
                    tile:element.tile
                })
            }
        });

        data.forEach(element => {
            Object.entries(element).forEach( o => (o[1] === "" ? delete element[o[0]] : 0))
        });
        var Data_List = {
            festivalDay:this.state.festivalDay,
            beyondList:data
        }
        this.apiserve.sendevent("homePage|beyondList|edit", Data_List)
    }

    render() {
        return (
            <React.Fragment>
                <div className="right_side_wrapper artistView_wrapper">
                    <ul className="fpg_admin_tab disp_flex small_list_tab" style={{height:"57px"}}>
                       
                    </ul>
                    
                    <div className="ticketing_content home_content about_sundance">
                        <div className="ticketing_wrapper fpg_tabcontent">
                            <div className="field_row horizontal_field">
                                <TextField
                                    type="text"
                                    label="Festival Day"
                                    name="festivalDay"
                                    value={this.state.festivalDay}
                                    onChange={(e) => this.onInputChange(e)}
                                />
                            </div>
                            <h4 className="uppercase ticket_page_title mt_25 mb_15">Beyond Festival Tiles</h4>
                            <div className="d_flex">
                                {this.state.beyondList.map((tile,i)=>{
                                    return(
                                        <div className="section_box help_box fest_time_home_content">
                                        <div className="header">
                                            <p>Tile {""} {tile.tile}</p>
                                        </div>
                                        <div className="section_content">
                                            <div className="d_flex">
                                                <div className="section_fields">
                                                    <div className="field_row horizontal_field">
                                                        <div className="d_flex">
                                                            <div className="">
                                                                <FestDropDown label="Event Type" 
                                                                    options={this.state.options} 
                                                                    name="eventType" 
                                                                    value={tile.eventType}
                                                                    onChange={(e)=>this.onChangeEventType(e,tile._id)}/>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                    <div>
                                                        <div className="field_row horizontal_field">
                                                            <div className="field_row_inner">
                                                                <label>Events (MT)</label>
                                                                <div className="customCheckBox">
                                                                    <div className="search_wrap field_input relative">
                                                                            <input type="text" 
                                                                            name="searchTitle" 
                                                                            placeholder="Search here" 
                                                                            value={tile.searchTitle}
                                                                            onChange={(e) => this.onSearchChange(e,tile._id)}
                                                                            />
                                                                        <span className="search_icon pointer"> <SearchIcon /> </span>
                                                                    </div>
                                                                    
                                                                    {tile._id === this.state.storeID && 
                                                                        this.state.checkList.map((item,)=>{
                                                                        return(
                                                                        <div className="check_box_select">
                                                                            <CheckBox 
                                                                                name='selectShortFilm'
                                                                                checked={tile.checked}
                                                                                value={item._id}
                                                                                onChange={(e) => this.checkListFestHome(e, item,item._id,tile._id)}
                                                                                label={item.title ? item.title : item.eventTitle ? item.eventTitle : item.offerTitle}
                                                                                type="checkbox"
                                                                                id={item._id}
                                                                            /> 
                                                                        </div>
                                                                        )
                                                                    })}

                                                                    <div className="beyond_festival_tiles_sec">
                                                                        <p>{tile?.checkDetails?.title ? tile?.checkDetails?.title : tile?.checkDetails?.eventTitle ? tile?.checkDetails?.eventTitle : tile?.checkDetails?.offerTitle }</p>
                                                                        {tile?.checkDetails?.eventDate ? 
                                                                            <p> 
                                                                                {tile?.checkDetails?.eventDate && tile?.checkDetails?.eventDate.map((dateItem) => {
                                                                                    return (<span>{dateItem.dateKey ? 'All Festival' : moment.tz(dateItem.date, "US/Mountain").format('MMM DD - hh:mm A')}</span>)
                                                                                })}
                                                                            </p>
                                                                            :
                                                                            <p> 
                                                                                {tile?.checkDetails?.dateTime && tile?.checkDetails?.dateTime.map((dateItem) => {
                                                                                    return (<p>{moment.tz(dateItem.date, "US/Mountain").format('MMM DD - hh:mm A')}</p>)
                                                                                })}
                                                                            </p>
                                                                        }       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                })}
                               
                      
                            </div>
                        </div>
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.cancelFn()}
                                >
                                Cancel
                            </button>
                            <button
                                className="orangeBTN active"
                                type="button"
                                onClick={this.submitFn}
                            >
                                Save
                            </button>
                        </div>
                    </div>
               </div>
            </React.Fragment>
        )
    }
}
